import { useEffect, useState } from "react"
import readCookie from "../utils/read-cookie"
import readSubcookie from "../utils/read-subcookie"

export const isCookieConsentSet = (): boolean => {
  const oneTrustCookie = readCookie("OptanonConsent")
  return !!oneTrustCookie
}

export const getConsentValues = () => {
  const oneTrustCookie = readCookie("OptanonConsent")
  const consentMap: Record<string, boolean> = {}
  if (oneTrustCookie) {
    const groups = readSubcookie(oneTrustCookie, "groups") ?? ""
    groups.split(",").forEach((group) => {
      const tuple = group.split(":")
      consentMap[tuple[0]] = tuple[1] === "1"
    })

    return consentMap
  }
  return undefined
}

export const hasFunctionalCookieConsent = () => {
  if (!isCookieConsentSet()) return false
  const values = getConsentValues()
  return values?.funcs
}

export const useCookieConsent = () => {
  const [triggeredConsentValues, setTriggerdConsentValue] = useState(false)
  const [consentValues, setConsentValue] = useState(getConsentValues())
  const isOneTrustCookieSet = !!readCookie("OptanonConsent")
  const hasFunctionalCookieConsent = isOneTrustCookieSet && consentValues?.funcs

  useEffect(() => {
    // Added an event listener provided by OneTrust called 'consent.onetrust' that checks if the user toggeled on the 'funcs' cookie
    window.addEventListener("consent.onetrust", (e) => {
      if ("detail" in e && Array.isArray(e.detail) && e.detail.includes("funcs")) {
        setTriggerdConsentValue(!triggeredConsentValues)
        setConsentValue(getConsentValues())
      }
    })
  }, [triggeredConsentValues])

  return { isOneTrustCookieSet, consentValues, hasFunctionalCookieConsent }
}
